
const { doExec } = require('./request')

module.exports = {
    // 微信登录
    wxLogin (opts) {
        return doExec('mobile/system/auth/weixinLogin', opts, 'urlencoded')
    },
    // 登录验证
    checkLogin (opts) {
        return doExec('mobile/system/auth/checkLogin', opts, null, 'get')
    },
    // 发送手机验证码
    getPhoneCode (opts) {
        return doExec('mobile/system/auth/code', opts, null, 'get')
    },
    // 绑定手机号
    bindPhone (opts) {
        return doExec('mobile/system/auth/bindingMobile', opts)
    },
    // 查询字典数据
    getDictData (opts) {
        return doExec('mobile/system/dict/listDictData', opts, null, 'get')
    },
    // 获取微信jsapi参数
    getWxConfig (opts) {
        return doExec('pay/js-sdk', opts, null, 'get')
    },
    // 获取支付参数 未使用！
    getPayParams (opts) {
        return doExec('getPreId', opts, null, 'get')
    },
    // 查询实名状态
    getRealRegisterStatus () {
      return doExec('mobile/system/auth/judgeIfAutonym')
    }
}